import React, { useState } from 'react';
import MultiChatView from './MultiChatView';
import SourcesPanel from './SourcesPanel';
import DeliverablesPanel from './DeliverablesPanel';
import HistoryPanel from './HistoryPanel';

const WorkspaceShell = ({ caseId, caseName, activeTab = 'chat', onSwitchCase = null }) => {
  const [runCount, setRunCount] = useState(0);
  const [deliverableCount, setDeliverableCount] = useState(0);

  console.log('[WorkspaceShell] Rendering:', { caseId, caseName, activeTab });

  return (
    <div className="h-full bg-white">
      {activeTab === 'chat' && (
        <MultiChatView 
          caseId={caseId}
          caseName={caseName}
          onSwitchCase={onSwitchCase}
        />
      )}
      {activeTab === 'sources' && (
        <SourcesPanel caseId={caseId} />
      )}
      {activeTab === 'deliverables' && (
        <DeliverablesPanel 
          caseId={caseId}
          onCountChange={setDeliverableCount}
        />
      )}
      {activeTab === 'history' && (
        <HistoryPanel 
          caseId={caseId}
          onCountChange={setRunCount}
        />
      )}
    </div>
  );
};

export default WorkspaceShell;
